<script>
  import { onMount } from "svelte";
  import Notification from "../components/Notification.svelte";
  import Alert from "../components/Alert.svelte";
  import { alerts } from "./alerts";

  let showNotification = false;
  let message = "";
  let notificationType = "";

  let isAuthenticated = false;
  let isLoading = true;
  let showMessage = false;
  let isSubmitting = false;

  onMount(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    isAuthenticated = userData !== null;
    isLoading = false;
    if (!isAuthenticated) {
      // setTimeout(() => {
      //   navigate("#/login");
      //   window.location.reload();
      // }, 3000);
    } else {
      showMessage = true;
      window.location.href = "#/";
      // setTimeout(() => {
      //   navigate("#/");
      //   window.location.reload();
      // }, 3000);
    }
  });

  let email = "";
  let password = "";
  let code = "";
  let showCodeInput = false;
  let successMessage = "";
  let errorMessage = "";

  let enableCodeInput = false;

  async function handleSubmit(event) {
    event.preventDefault();

    const formData = {
      email,
      password,
      code,
    };

    try {
      const response = await fetch("https://api.trulens.ae/api/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      // console.log(data);

      if (data.success) {
        localStorage.setItem("userData", JSON.stringify(data));
        // alerts.add({
        //   message: "Login successful!",
        //   type: "success",
        //   timeout: 3000,
        // });
        successMessage = "Login successful!";
        message = "Login successful!";
        showNotification = true;
        notificationType = "success";
        setTimeout(() => (showNotification = false), 3000);
        setTimeout(() => {
          successMessage = "";
          window.location.href = "/";
        }, 3000);
      } else {
        errorMessage = data.message || "Login failed!";
        message = data.message || "Login failed!";
        showNotification = true;
        notificationType = "danger";
        setTimeout(() => (showNotification = false), 3000);
        // alerts.add({
        //   message: errorMessage,
        //   type: "danger",
        //   timeout: 3000,
        // });
        // setTimeout(() => {
        //   errorMessage = "";
        // }, 3000);
      }
    } catch (error) {
      // console.error("Error:", error);
      errorMessage = "Login failed!";
      message = "Login failed!";
      showNotification = true;
      notificationType = "danger";
      setTimeout(() => (showNotification = false), 3000);
      // alerts.add({ message: errorMessage, type: "danger", timeout: 3000 });
      // setTimeout(() => {
      //   errorMessage = "";
      // }, 3000);
    }
  }

  function toggleEye() {
    enableCodeInput = !enableCodeInput;
  }
</script>

<link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css"
  integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N"
  crossorigin="anonymous"
/>
<link
  href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet"
/>
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
/>

<main>
  <Notification {message} show={showNotification} type={notificationType}/>

  {#if showMessage}
    <div class="message">
      You are already logged in. Redirecting to home page...
    </div>
  {:else}
    <div class="icon-container">
      <!-- <i class="fas fa-user fa-5x"></i>
      <h1 style="text-align: center; color: #FF3C82;">
        Tru<span style="color: #1E92FF;">Lens</span>
      </h1> -->
      <div style="text-align: center;">
        <img
          src="/PrimaryLogo.png"
          alt="TruLens"
          style="width: 250px; height: auto; background-color: #ffffff;"
        />
        <h1 style="text-align: center; color: #FF3C82;">Log in</h1>
      </div>
    </div>

    <form on:submit={handleSubmit}>
      <div class="input-group">
        <i class="fas fa-envelope"></i>
        <input type="email" bind:value={email} placeholder="Email" />
      </div>
      <div class="input-group">
        <i class="fas fa-lock"></i>
        <input type="password" bind:value={password} placeholder="Password" />
      </div>

      <div class="code-group">
        <div class="input-group code-input">
          <i class="fas fa-key"></i>
          <input
            type="text"
            bind:value={code}
            placeholder="2FA OTP Code"
            disabled={!enableCodeInput}
          />
        </div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <i
          class="eye-icon fas {enableCodeInput ? 'fa-eye' : 'fa-eye-slash'}"
          on:click={toggleEye}
        ></i>
      </div>

      <div class="button-container">
        <button type="submit">Login</button>
      </div>

      <a href="#/reset-password" class="reset-password-link">Reset Password</a>

      <a href="/" class="back-home-link">Go back</a>
    </form>
  {/if}
</main>

<style>
  main {
    height: 100vh;
    margin: 0;
    display: grid;
    justify-content: center;
    align-items: center;
  }
  form {
    width: 500px;
    height: 90%;
    padding: 40px;
    border-radius: 5px;
    margin-bottom: 20px;
  }

  .input-group {
    position: relative;
  }

  .input-group i {
    color: #000000;
    font-size: 20px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
  }

  .input-group input[type="email"],
  .input-group input[type="text"],
  .input-group input[type="password"] {
    width: calc(100% - 10px);
    padding-left: 40px;
    border-radius: 5px;
    margin: 5px 0;
    border: 1px solid #ffafcc;
    box-sizing: border-box;
  }

  .button-container {
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
    left: 0;
  }

  button[type="submit"] {
    width: calc(100% - 0.5%);
    padding: 10px;
    margin-top: 10px;
    background-color: #ff3c82;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  button[type="submit"]:hover {
    background-color: #b683d4;
  }

  .back-home-link {
    display: block;
    margin-top: 10px;
    font-size: 1.2rem;
    color: #1e92ff;
    text-decoration: none;
    text-align: right;
    font-weight: bold;
  }

  .back-home-link:hover {
    text-decoration: none;
  }

  .message {
    max-width: 200px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f9f9f9;
    text-align: center;
    margin: 0 auto;
  }

  .icon-container {
    font-size: 2.8rem;
    margin-top: 20px;
    text-align: center;
    margin-bottom: 0px;
  }

  .icon-container i {
    font-size: 2.8rem;
    color: #ff3c82;
  }

  .code-group {
    display: flex;
    align-items: center;
  }

  .code-group .code-input {
    flex: 1;
  }

  .eye-icon {
    cursor: pointer;
    font-size: 1.5rem;
    margin-right: 10px;
    color: #ff3c82;
  }

  @media (max-width: 768px) {
    form {
      width: 100%;
      padding: 20px;
    }

    .input-group i {
      font-size: 16px;
    }

    .input-group input[type="email"],
    .input-group input[type="text"],
    .input-group input[type="password"] {
      width: calc(100% - 1%);
      padding-left: 30px;
      margin: 3px 0;
    }

    .button-container {
      justify-content: center;
      margin-right: 0;
    }

    button[type="submit"] {
      width: 100%;
    }

    .back-home-link {
      text-align: right;
    }

    .icon-container {
      margin-top: 10px;
      font-size: 1.5rem;
      text-align: center;
      margin-bottom: 0px;
    }

    .icon-container i {
      margin-top: 10px;
      font-size: 2.2rem;
      text-align: center;
    }
  }
</style>
